import React, { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper.min.css';
import 'swiper/components/navigation/navigation.min.css';
import 'swiper/components/thumbs/thumbs.min.css';
import './index.scss';
import SwiperCore, { Navigation, Thumbs, Keyboard } from 'swiper/core';
import { useModal } from 'hooks';
import { Overlay } from '@estudio-nk/the-crane-club-client-lib';
import { YoutubeEmbed, Icon } from 'components';
import { getYouTubeVideoID } from 'utils/youtube';

SwiperCore.use([Navigation, Thumbs, Keyboard]);

interface PublicationMediaProps {
  files: PublicationFile[];
  videoURL?: string;
}

export const PublicationMedia = ({
  files,
  videoURL
}: PublicationMediaProps) => {
  const [thumbsSwiper, setThumbsSwiper] = useState<any>(null);
  const [showSwiper, setShowSwiper] = useState(false);
  const { toggleModal, visible } = useModal();
  const [actualIndex, setActualIndex] = useState(0);
  const videoId = getYouTubeVideoID(videoURL);
  console.log({ files });
  const sortedFiles = files?.sort((a: any, b: any) =>
    a.order > b.order ? 1 : -1
  );

  const handleOnSlideChange = (index: number) => {
    setActualIndex(index);
  };

  const slides = sortedFiles?.map((file, i) => (
    <SwiperSlide key={i}>
      <img
        src={file.url}
        alt={`Crane media ${i + 1}`}
        className="object-contain"
      />
    </SwiperSlide>
  ));
  const thumbnails = sortedFiles?.map((file, i) => (
    <SwiperSlide key={i}>
      <img
        src={file.url}
        alt={`Crane media ${i + 1}`}
        className="object-cover"
      />
    </SwiperSlide>
  ));

  useEffect(() => {
    setTimeout(() => {
      setShowSwiper(true);
    }, 500);
  }, []);

  const renderSlides = (reRender: any) => (
    <>
      <Swiper
        // style={{
        //   '--swiper-navigation-color': '#fff',
        //   '--swiper-pagination-color': '#fff'
        // }}
        spaceBetween={10}
        navigation={reRender}
        onActiveIndexChange={(swiper) =>
          handleOnSlideChange(swiper.activeIndex)
        }
        thumbs={{ swiper: thumbsSwiper }}
        className="main-swiper mb-6 bg-silver-300 rounded-lg"
      >
        {slides}
        {videoURL && (
          <SwiperSlide>
            <YoutubeEmbed embedId={videoId} />
          </SwiperSlide>
        )}
        <Icon
          onClick={toggleModal}
          name="FullScreen"
          width={18}
          height={18}
          rounded={true}
          center={true}
          canvasWidth={40}
          canvasHeight={40}
          className="absolute bottom-5 right-5 cb-icon z-20"
        />
      </Swiper>

      <Swiper
        onSwiper={setThumbsSwiper}
        spaceBetween={24}
        slidesPerView={4}
        freeMode={true}
        watchSlidesVisibility={true}
        watchSlidesProgress={true}
        className="thumbs-swiper"
      >
        {thumbnails}
        {videoURL && (
          <SwiperSlide className="flex items-center justify-center">
            <div
              className="bg"
              style={{
                backgroundImage: `url(https://img.youtube.com/vi/${videoId}/0.jpg)`
              }}
            ></div>
            <Icon
              name="Play"
              width={44}
              height={44}
              canvasWidth={44}
              canvasHeight={44}
              className="absolute top-2/4 left-2/4 z-1 transform -translate-x-1/2 -translate-y-1/2"
            />
          </SwiperSlide>
        )}
      </Swiper>
    </>
  );

  return (
    <div className="cb-media">
      {renderSlides(showSwiper)}

      <Overlay visible={visible} toggle={toggleModal} containerClasses="">
        <Swiper
          className="publication-fullscreen-swiper rounded-lg"
          onSwiper={setThumbsSwiper}
          slidesPerView={1}
          initialSlide={actualIndex}
          keyboard={{ enabled: true }}
          navigation={true}
        >
          {slides}
          {videoURL && (
            <SwiperSlide>
              <YoutubeEmbed embedId={videoId} />
            </SwiperSlide>
          )}
        </Swiper>
      </Overlay>
    </div>
  );
};
